export const environment = {
  name: 'staging',
  production: false,
  useMock: false,
  showDevelopmentScreens: false,
  showMaintenanceTypeConfigurations: true,
  apiBaseUrl: 'https://pr-api.relinns.website'
};
